import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {takeLeading} from "@redux-saga/core/effects";
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {
    addSocialTemplatesFail,
    addSocialTemplatesSuccess,
    fetchAdminOKRFail,
    fetchAdminOKRSuccess,
    fetchSocialTemplatesFail,
    fetchSocialTemplatesSuccess,
    fetchSubscriptionFail,
    fetchManageSubscriptionFail,
    fetchManageSubscriptionSuccess,
    fetchSubscriptionSuccess,
    sendSocialTemplateTestFail,
    sendSocialTemplateTestSuccess,
    updateBRSubscriptionFail,
    updateBRSubscriptionSuccess,
    updateSocialTemplatesFail,
    updateSocialTemplatesSuccess,
    fetchManageSubTypeSuccess,
    fetchManageSubTypeFail,
    fetchAllEntitiesSuccess,
    fetchAllEntitiesFail,
    verifyPrimaryDomainSuccess,
    verifyPrimaryDomainFail,
    updateEntityNameSuccess,
    updateEntityNameFail,
    updatePentestSettingForEntitySuccess,
    updatePentestSettingForEntityFail,
    updateSocialTestSettingForEntitySuccess,
    updateSocialTestSettingForEntityFail,
    updateEntitySuccess,
    updateEntityFail,
    updateEntitySettingsFail, updateEntitySettingsSuccess
} from "../actions/Admin";
import {
    ADD_BR_SUBSCRIPTION,
    ADD_SOCIAL_TEMPLATES,
    FETCH_ADMIN_OKR,
    FETCH_ALL_ENTITIES,
    FETCH_BR_SUBSCRIPTION,
    FETCH_MANAGE_BR_SUBSCRIPTION,
    FETCH_MANAGE_SUB_TYPE,
    FETCH_SOCIAL_TEMPLATES,
    SEND_SOCIAL_TEMPLATE_TEST,
    UPDATE_BR_SUBSCRIPTION,
    UPDATE_ENTITY,
    UPDATE_ENTITY_NAME,
    UPDATE_ENTITY_SETTINGS,
    UPDATE_PENTEST_SETTING_FOR_ENTITY,
    UPDATE_SOCIAL_TEMPLATES,
    UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY,
    VERIFY_PRIMARY_DOMAIN
} from "../constants/ActionTypes";
import {addBRSubscriptionFail, addBRSubscriptionSuccess} from "../actions";

/* sarahp***************************
   Fetching okr data
   *************************** */

const getAdminOKRRequest = async () =>
    await  apiClient.get('/okr', {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getAdminOKRGenerator() {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchAdminOKR";     console.group(`${standardName} Generator...: `);
    // const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(getAdminOKRRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(fetchAdminOKRSuccess({inboundData: request.data}));
    } else if (request.statusText === "Bad Gateway") {
        console.log("Admin ORK details unavailable on development server")
        yield put(fetchAdminOKRFail({request: request.data,}));
    } else {
        yield put(fetchAdminOKRFail({request: request.data,}));

    }

    console.groupEnd();
}


export function* watchLeadingAdminOKRGenerator() {
    yield takeLeading(FETCH_ADMIN_OKR, getAdminOKRGenerator);
}

/* sarahp***************************
   Fetching social phishing templates
   *************************** */

const getSocialTemplatesRequest = async () =>
    await  apiClient.get('/risk/social/templates', {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getSocialTemplatesGenerator() {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchSocialTemplates";     console.group(`${standardName} Generator...: `);
    // const {customerId, firstName, lastName, email, isManager } = payload;
    const request = yield call(getSocialTemplatesRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(fetchSocialTemplatesSuccess(
            {
                inboundData: request.data
            }));
    } else {
        yield put(fetchSocialTemplatesFail(
            {
                request: request.data,
            }));

    }

    console.groupEnd();
}

export function* watchLeadingSocialTemplatesGenerator() {
    yield takeLeading(FETCH_SOCIAL_TEMPLATES, getSocialTemplatesGenerator);
}


/* sarahp***************************
   Adding a social phishing template
   *************************** */
const addSocialTemplateRequest = async (
    {
        socialAccountId,
        subjectString,
        htmlMessage,
        plainTextMessage,
        statusId,
        socialThemeId,
        payloadTypeId,
        payloadTemplate,
        senderName,
        technologyTypeId,
        hostingProviderId,
        vectorTypeId,
        entityToSendTo
    }
) =>
    await  apiClient.post(`/risk/social/templates`,{
            social_account: socialAccountId,
            subject: subjectString,
            html_message: htmlMessage,
            plaintext_message: plainTextMessage,
            status: statusId,
            social_theme: socialThemeId,
            has_payload: payloadTypeId,
            payload_template: payloadTemplate ? payloadTemplate : 0,
            sender_name: senderName ? senderName : null,
            associated_technology_tag: technologyTypeId ? technologyTypeId : null,
            associated_hosting_provider_tag: hostingProviderId ? hostingProviderId : null,
            associated_vector_definition: vectorTypeId ? vectorTypeId : null,
            associated_entity: entityToSendTo ? entityToSendTo : null,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* addSocialTemplateGenerator({payload}) {
    /*  *******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addSocialTemplate";     console.group(`${standardName} Generator...: `);
    const {socialAccountId,
        subjectString,
        htmlMessage,
        plainTextMessage,
        statusId,
        socialThemeId,
        payloadTypeId,
        payloadTemplate,
        senderName,
        technologyTypeId,
        hostingProviderId,
        vectorTypeId,
        entityToSendTo,} = payload;
    const request = yield call(addSocialTemplateRequest,
        {
            socialAccountId,
            subjectString,
            htmlMessage,
            plainTextMessage,
            statusId,
            socialThemeId,
            payloadTypeId,
            payloadTemplate,
            senderName,
            technologyTypeId,
            hostingProviderId,
            vectorTypeId,
            entityToSendTo,
        },
    );
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addSocialTemplatesSuccess(
            {
                inboundData: request.data,
            }));
    } else {
        yield put(addSocialTemplatesFail({
            request: request.data,
        }));
    }
    console.groupEnd();
}

export function* watchLeadingAddSocialTemplateGenerator() {
    yield takeLeading(ADD_SOCIAL_TEMPLATES, addSocialTemplateGenerator);
}

/* sarahp***************************
   updating a social phishing template
   *************************** */

const updateSocialTemplateRequest = async (templateId, updateObject)=>
    await apiClient.put(`/risk/social/templates`, {
            template: templateId,
            ...updateObject
        }, {timeout: 10000}
    )
        .then(data=> data)
        .catch(error => error);

function* updateSocialTemplateGenerator({payload}){
    /*  *******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */

    const standardName = "updateSocialTemplateGenerator"; console.group(`${standardName} Generator...: `);
    const {templateId, updatesToMake} = payload;

    //clean out the object of nulls
    console.log("About to clean up the updatesToMakeObject to send a streamlined put request for a template update. updatesToMake", updatesToMake, templateId);
    let cleanUpdateObject = Object.fromEntries(Object.entries(updatesToMake).filter(([_, v]) => v != null));
    console.log("Clean object for us is ", cleanUpdateObject);

    const request = yield call(updateSocialTemplateRequest, templateId, cleanUpdateObject);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if(didRequestSucceed) {
        yield put(updateSocialTemplatesSuccess(
            {
                templateId,
                inboundData: request.data,
            }
        ));
    } else{
        yield put(updateSocialTemplatesFail(
            {
                templateId,
                request: request.data,
            }
        ))
    }
    console.groupEnd();


}

export function* watchLeadingUpdateSocialTemplateGenerator() {
    yield takeLeading(UPDATE_SOCIAL_TEMPLATES, updateSocialTemplateGenerator);
}

/* sarahp***************************
   updating a social phishing template
   *************************** */

const sendSocialTemplateTestRequest = async (templateId)=>
    await apiClient.post(`/risk/social/templates/test`, {
            template: templateId,
        }, {timeout: 10000}
    )
        .then(data=> data)
        .catch(error => error);

function* sendSocialTemplateTestGenerator({payload}) {
    /*  *******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "sendSocialTemplateTest";     console.group(`${standardName} Generator...: `);
    const {templateId, } = payload;
    const request = yield call(sendSocialTemplateTestRequest, templateId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(sendSocialTemplateTestSuccess(
            {
                templateId,
                inboundData: request.data,
            }));
    } else {
        yield put(sendSocialTemplateTestFail({
            templateId,
            request: request.data,
        }));
    }
    console.groupEnd();
}

export function* watchLeadingSendSocialTemplateTestGenerator() {
    yield takeLeading(SEND_SOCIAL_TEMPLATE_TEST, sendSocialTemplateTestGenerator);
}

/* ***************************
Adding a BR Subscription record
*************************** */

const postBRSubscriptionRequest = async (customerId, subscriptionType, subscriptionLevel, subscriptionStart, subscriptionEnd) =>
    await  apiClient.post(`/subscriptions`,{
            customer: customerId,
            subscription_type: subscriptionType,
            subscription_level: subscriptionLevel,
            subscription_start: subscriptionStart,
            subscription_end: subscriptionEnd,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);



function* postBRSubscriptionGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId, subscriptionType, subscriptionLevel, subscriptionStart, subscriptionEnd} = payload;
    const request = yield call(postBRSubscriptionRequest, customerId, subscriptionType, subscriptionLevel, subscriptionStart, subscriptionEnd);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRSubscriptionSuccess(
            {
                customerId: customerId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRSubscriptionFail({
            customerId: customerId,
            request: request.data,
        }));
    }
    console.groupEnd();
}

export function* watchLeadingPostBRSubscriptionGenerator() {
    yield takeLeading(ADD_BR_SUBSCRIPTION, postBRSubscriptionGenerator);
}

/* ***************************
   Updating a BR Subscription record
   *************************** */

const putBRSubscriptionRequest = async (subscriptionId, cleanUpdateObject) =>
    await  apiClient.put(`/subscriptions`,{
            subscription: subscriptionId,
            ...cleanUpdateObject
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);


function* putBRSubscriptionGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId, subscriptionId, updatesToMake} = payload;

    //clean out the object of nulls
    console.log("About to clean up the updatesToMakeObject to send a streamlined put request for a subscription. updatesToMake", updatesToMake);
    let cleanUpdateObject = Object.fromEntries(Object.entries(updatesToMake).filter(([_, v]) => v != null));
    console.log("Clean object for us is ", cleanUpdateObject);

    const request = yield call(putBRSubscriptionRequest, subscriptionId, cleanUpdateObject);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRSubscriptionSuccess(
            {
                customerId,
                subscriptionId: subscriptionId,
                inboundData: request.data,
            }));
    } else {
        console.warn("putBRSubscriptionGenerator failed here is request:", request);
        yield put(updateBRSubscriptionFail({
            customerId,
            subscriptionId: subscriptionId,
            request: request.data,
        }));
    }
    console.groupEnd();
}

export function* watchLeadingPutBRSubscriptionGenerator() {
    yield takeLeading(UPDATE_BR_SUBSCRIPTION, putBRSubscriptionGenerator);
}


/* sarahp***************************
   Fetching self managed subscriptions redirect
   *************************** */

const getManageSubscriptionRequest = async (customerId) =>
    await  apiClient.get(`/subscriptions/manage?customer=${customerId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getManageSubscriptionGenerator({payload}) {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchManageSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId,} = payload;
    const request = yield call(getManageSubscriptionRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchManageSubscriptionSuccess(
            {
                customerId: customerId,
                inboundData: request.data
            }));
    } else {
        yield put(fetchManageSubscriptionFail(
            {
                request: request.data,
            }));

    }

    console.groupEnd();
}

export function* watchLeadingGetManageSubscriptionGenerator() {
    yield takeLeading(FETCH_MANAGE_BR_SUBSCRIPTION, getManageSubscriptionGenerator);
}


/* sarahp***************************
   Fetching self managed subscriptions redirect with specific type of subscription to update
   *************************** */

const getManageSubTypeRequest = async (customerId, subType) =>
    await  apiClient.get(`/subscriptions/manage?customer=${customerId}&price=${subType}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getManageSubTypeGenerator({payload}) {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchManageSubType";     console.group(`${standardName} Generator...: `);
    const {customerId, subType} = payload;
    const request = yield call(getManageSubTypeRequest, customerId, subType);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchManageSubTypeSuccess(
            {
                customerId: customerId,
                inboundData: request.data
            }));
    } else {
        yield put(fetchManageSubTypeFail(
            {
                request: request.data,
            }));

    }

    console.groupEnd();
}

export function* watchLeadingGetManageSubTypeGenerator() {
    yield takeLeading(FETCH_MANAGE_SUB_TYPE, getManageSubTypeGenerator);
}

/* sarahp***************************
   Fetching subscriptions information for customer
   *************************** */

const getSubscriptionRequest = async (customerId) =>
    await  apiClient.get(`/subscriptions?customer=${customerId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getSubscriptionGenerator({payload}) {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchSubscription";     console.group(`${standardName} Generator...: `);
    const {customerId,} = payload;
    const request = yield call(getSubscriptionRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchSubscriptionSuccess(
            {
                customerId: customerId,
                inboundData: request.data
            }));
    } else {
        yield put(fetchSubscriptionFail(
            {
                request: request.data,
            }));

    }

    console.groupEnd();
}

export function* watchLeadingGetSubscriptionGenerator() {
    yield takeLeading(FETCH_BR_SUBSCRIPTION, getSubscriptionGenerator);
}

/* sarahp***************************
   Fetching subscriptions information for customer
   *************************** */

const getAllEntitiesRequest = async (pageNumber) =>
    await  apiClient.get(`/risk/entity/list?page=${pageNumber}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getAllEntitiesGenerator({payload}) {
    /*  sarahp*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getAllEntitiesRequest";     console.group(`${standardName} Generator...: `);
    const {pageNumber,} = payload;
    const request = yield call(getAllEntitiesRequest, pageNumber);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchAllEntitiesSuccess(
            {
                pageNumber: pageNumber,
                inboundData: request.data
            }));
    } else {
        yield put(fetchAllEntitiesFail(
            {
                pageNumber: pageNumber,
                request: request.data,
            }));

    }

    console.groupEnd();
}

export function* watchLeadingGetAllEntitiesGenerator() {
    yield takeLeading(FETCH_ALL_ENTITIES, getAllEntitiesGenerator);
}
/* ***************************
   Verify ownership of a primary domain for customer
   *************************** */

const verifyPrimaryDomainRequest = async (entityId, domainId, newStatus) =>
    await  apiClient.put(`/risk/domain`,{
            id: domainId,
            verified: newStatus
        }, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* verifyPrimaryDomainGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "verifyPrimaryDomain";     console.group(`${standardName} Generator...: `);
    const {entityId, domainId, newStatus} = payload;
    const request = yield call(verifyPrimaryDomainRequest, entityId, domainId, newStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(verifyPrimaryDomainSuccess({
            entityId,
            domainId,
            newStatus,
            inboundData: request.data,
        }));
    } else {
        yield put(verifyPrimaryDomainFail({
            entityId,
            domainId,
            newStatus,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingVerifyPrimaryDomainGenerator() {
    yield takeLeading(VERIFY_PRIMARY_DOMAIN, verifyPrimaryDomainGenerator);
}

/* ***************************
   Update entity name for entity in a portfolio (staff call only)
   *************************** */

const updateEntityRequest = async (entityId, property, updatedValue) =>
    await  apiClient.put(`/risk/entity`,{
            id: entityId,
            [`${property}`]: updatedValue
        }, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* updateEntityGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below. moved and updated sarahp sep2023
         ********************************** */
    const {entityId, property ,updatedValue} = payload;

    const standardName = `updateEntity_${property}`;     console.group(`${standardName} Generator...: `);
    const request = yield call(updateEntityRequest, entityId, property ,updatedValue);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateEntitySuccess({
            entityId,
            property,
            updatedValue,
            inboundData: request.data,
        }));
    } else {
        yield put(updateEntityFail({
            entityId,
            property,
            updatedValue,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingUpdateEntityGenerator() {
    yield takeLeading(UPDATE_ENTITY, updateEntityGenerator);
}


/* ***************************
   Update penetration testing status for an entity (staff call only)
   *************************** */
const putUpdatePenTestingSettingForEntityRequest = async (entityId, newStatus) =>
    await apiClient.put(`/risk/entity/authorize`, {
        entity: entityId,
        authorize: newStatus
    }, {timeout: 2500}
    )
        .then(data => data)
        .catch(error => error);

function* putUpdatePenTestingSettingForEntityRequestGenerator({payload}){

    const standardName = "updatePentestingSettingForEntity";    console.group(`${standardName} Generator...:` );
    const {entityId, newStatus} = payload;
    const request = yield call(putUpdatePenTestingSettingForEntityRequest, entityId, newStatus);

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if(didRequestSucceed){
        yield put(updatePentestSettingForEntitySuccess({
            entityId: entityId,
            newStatus: newStatus,
            inboundData: request.data,
        }));
    }else {
        yield put(updatePentestSettingForEntityFail({
            entityId: entityId,
            inboundData: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutUpdatePenTestingSettingForEntityGenerator(){
    yield takeLeading(UPDATE_PENTEST_SETTING_FOR_ENTITY, putUpdatePenTestingSettingForEntityRequestGenerator);
}

/* ***************************
   Update social testing status for an entity (staff call only)
   *************************** */
const putUpdateSocialTestingSettingForEntityRequest = async (entityId, newStatus) =>
    await apiClient.put(`/risk/entity/authorize`, {
            entity: entityId,
            social: newStatus
        }, {timeout: 2500}
    )
        .then(data => data)
        .catch(error => error);

function* putUpdateSocialTestingSettingForEntityRequestGenerator({payload}){

    const standardName = "updateSocialTestSettingForEntity";    console.group(`${standardName} Generator...:` );
    const {entityId, newStatus} = payload;
    const request = yield call(putUpdateSocialTestingSettingForEntityRequest, entityId, newStatus);

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if(didRequestSucceed){
        yield put(updateSocialTestSettingForEntitySuccess({
            entityId: entityId,
            newStatus: newStatus,
            inboundData: request.data,
        }));
    }else {
        yield put(updateSocialTestSettingForEntityFail({
            entityId: entityId,
            inboundData: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutUpdateSocialTestingSettingForEntityGenerator(){
    yield takeLeading(UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY, putUpdateSocialTestingSettingForEntityRequestGenerator);
}


const updateEntitySettingsRequest = async (entityId, property, updatedValue) =>
    await  apiClient.put(`/risk/entity/settings`,{
            entity: entityId,
            [`${property}`]: updatedValue
        }, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* updateEntitySettingsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below. moved and updated sarahp sep2023
         ********************************** */
    const {entityId, property ,updatedValue} = payload;

    const standardName = `updateEntitySettings_${property}`;     console.group(`${standardName} Generator...: `);
    const request = yield call(updateEntitySettingsRequest, entityId, property ,updatedValue);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateEntitySettingsSuccess({
            entityId,
            property,
            updatedValue,
            inboundData: request.data,
        }));
    } else {
        yield put(updateEntitySettingsFail({
            entityId,
            property,
            updatedValue,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingUpdateEntitySettingsGenerator() {
    yield takeLeading(UPDATE_ENTITY_SETTINGS, updateEntitySettingsGenerator);
}


/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingAdminOKRGenerator),
        fork(watchLeadingSocialTemplatesGenerator),
        fork(watchLeadingAddSocialTemplateGenerator),
        fork(watchLeadingUpdateSocialTemplateGenerator),
        fork(watchLeadingSendSocialTemplateTestGenerator),
        fork(watchLeadingPostBRSubscriptionGenerator),
        fork(watchLeadingPutBRSubscriptionGenerator),
        fork(watchLeadingGetManageSubscriptionGenerator),
        fork(watchLeadingGetManageSubTypeGenerator),
        fork(watchLeadingGetSubscriptionGenerator),
        fork(watchLeadingGetAllEntitiesGenerator),
        fork(watchLeadingVerifyPrimaryDomainGenerator),
        fork(watchLeadingUpdateEntityGenerator),
        fork(watchLeadingPutUpdatePenTestingSettingForEntityGenerator),
        fork(watchLeadingPutUpdateSocialTestingSettingForEntityGenerator),
        fork(watchLeadingUpdateEntitySettingsGenerator),



    ]);
}